import RaceForm from './RaceForm';

export default RaceForm;
